import type { ParsedErrorModel, PaymentErrorModel } from '@core/analytics/common/models/mixpanel.model';
import { isCodeDefect } from '../../shared/utils/paymentFailure';

export function usePaymentError() {
  const { $logger } = useNuxtApp();
  const { mixpanelPaymentError } = useMixpanel();

  function reportPaymentError(
    params: PaymentErrorModel,
    extra?: Record<string, unknown>,
  ): ParsedErrorModel {
    const parsedError = mixpanelPaymentError(params);

    if (isCodeDefect(params.error)) {
      $logger.error(params.error, {
        tags: {
          flow: 'payment',
          gateway: parsedError.gateway,
          type: parsedError.type,
        },
        extra: { ...parsedError, ...extra },
      });
    }

    return parsedError;
  }

  return { reportPaymentError };
}
